import "./Common.scss";

const CardEmpty = ({children}) => {
  return (
    <div className="card-empty">{children}</div>
  );
};

export default CardEmpty;
